module.exports = __webpack_public_path__ + "img/img-collaboration.1e82593b.png";